// Config/tablas.js
export const CONFIGURACIONES_TABLA = {
  Despacho: {
    headers: [
      "Id Despacho",
      "Id Despacho Terminal",
      "Terminal Despacho",
      "NIT Empresa Transporte",
      "Razón Social",
      "Número Pasajero",
      "Valor Tiquete",
      "Valor Total Tasa Uso",
      "Valor Prueba Alcoholimetría",
      "Tipo Despacho",
      "Observaciones",
      "Estado",
      "Fecha Creación",
      "Fecha Actualización"
    ],
    keys: [
      "id",
      "id_despacho_terminal",
      "terminal_despacho",
      "nit_empresa_transporte",
      "razon_social",
      "numero_pasajero",
      "valor_tiquete",
      "valor_total_tasa_uso",
      "valor_prueba_alcoholimetria",
      "tipo_despacho",
      "observaciones",
      "estado",
      "fecha_creacion",
      "fecha_actualizacion"
    ]
  },
  
  Vehiculo: {
    headers: [
      "Código Vehículo",
      "Id Despachos",
      "Placa",
      "SOAT",
      "Fecha Vencimiento SOAT",
      "Revisión Técnico Mecánica",
      "Fecha Revisión Técnico Mecánica",
      "Id Pólizas",
      "Tipo Póliza",
      "Vigencia",
      "Tarjeta Operación",
      "Fecha Tarjeta Operación",
      "Id Mantenimiento",
      "Fecha Mantenimiento",
      "Id Protocolo Alistamiento Diario",
      "Fecha Protocolo Alistamiento Diario",
      "Observaciones",
      "Clase",
      "Nivel Servicio",
      "Fecha Creación",
      "Fecha Actualización",
      "Estado"
    ],
    keys: [
      "id",
      "id_despachos",
      "placa",
      "soat",
      "fecha_vencimiento_soat",
      "revision_tecnico_mecanica",
      "fecha_revision_tecnico_mecanica",
      "id_polizas",
      "tipo_poliza",
      "vigencia",
      "tarjeta_operacion",
      "fecha_tarjeta_operacion",
      "id_matenimiento",
      "fecha_mantenimiento",
      "id_protocolo_alistamiento_diario",
      "fecha_protocolo_alistamiento_diario",
      "observaciones",
      "clase",
      "nivel_servicio",
      "fecha_creacion",
      "fecha_actualizacion",
      "estado"
    ]
  },

  Ruta: {
    headers: [
      "Id Ruta",
      "Id Despacho",
      "Id Ruta Autorizada",
      "Id Origen",
      "Detalle Origen",
      "Id Destino",
      "Detalle Destino",
      "Vía",
      "Centro Poblado Origen",
      "Centro Poblado Destino",
      "Observaciones",
      "Fecha Creación",
      "Fecha Actualización",
      "Estado"
    ],
    keys: [
      "id",
      "id_despacho",
      "id_ruta_autorizada",
      "id_origen",
      "detalle_origen",
      "id_destino",
      "detalle_destino",
      "via",
      "centro_poblado_origen",
      "centro_poblado_destino",
      "observaciones",
      "fecha_creacion",
      "fecha_actualizacion",
      "estado"
    ]
  },

  Autorizaciones: {
    headers: [
      "Id",
      "Id Despacho",
      "Fecha Viaje",
      "Origen",
      "Destino",
      "Tipo Identificación NNA",
      "Número Identificación NNA",
      "Nombres y Apellidos NNA",
      "Situación Discapacidad",
      "Tipo Discapacidad",
      "Pertenece Comunidad Étnica",
      "Tipo Población Étnica"
    ],
    keys: [
      "id",
      "id_despacho",
      "fechaViaje",
      "origen",
      "destino",
      "tipoIdentificacionNna",
      "numeroIdentificacionNna",
      "nombresApellidosNna",
      "situacionDiscapacidad",
      "tipoDiscapacidad",
      "perteneceComunidadEtnica",
      "tipoPoblacionEtnica"
    ]
  },

  Conductores: {
    headers: [
      "Id",
      "Id Despacho",
      "Tipo Identificación Conductor Principal",
      "Número Identificación Conductor Principal",
      "Primer Nombre Conductor Principal",
      "Segundo Nombre Conductor Principal",
      "Primer Apellido Conductor Principal",
      "Segundo Apellido Conductor Principal",
      "Licencia Conducción",
      "Estado"
    ],
    keys: [
      "id",
      "id_despacho",
      "tipo_identificacion_conductor_principal",
      "numero_identificacion",
      "primer_nombre_conductor_principal",
      "segundo_nombre_conductor_principal",
      "primer_apellido_conductor_principal",
      "segundo_apellido_conductor_principal",
      "licencia_conduccion",
      "estado"
    ]
  },

  Novedades: {
    headers: [
      "Id",
      "Id Despacho",
      "Descripción",
      "Fecha Creación",
      "Fecha Actualización",
      "Otros",
      "Estado",
      "Tipo Novedad Id"
    ],
    keys: [
      "id",
      "id_despacho",
      "descripcion",
      "fecha_creacion",
      "fecha_actualizacion",
      "otros",
      "estado",
      "tipo_novedad_id"
    ]
  },

  Llegadas: {
    headers: [
      "Id",
      "Tipo Llegada Id",
      "Despacho Id",
      "Terminal llegada",
      "Hora llegada",
      "Fecha llegada",
      "Fecha creación",
      "Fecha actualización",
      "Estado",
      "Número de Pasajeros"
    ],
    keys: [
      "id",
      "tipollegada_id",
      "despacho_id",
      "terminalllegada",
      "horallegada",
      "fechallegada",
      "fechacreacion",
      "fechaactualizacion",
      "estado",
      "numero_pasajero"
    ]
  },

  NovedadesVehiculo: {
    headers: [
      "Id",
      "Id Novedad",
      "Placa",
      "SOAT",
      "Fecha Vencimiento SOAT",
      "Revisión Técnico Mecánica",
      "Observaciones",
      "Estado"
    ],
    keys: [
      "id",
      "id_novedad",
      "placa",
      "soat",
      "fecha_vencimiento_soat",
      "revision_tecnico_mecanica",
      "observaciones",
      "estado"
    ]
  },

  NovedadesConductor: {
    headers: [
      "Id",
      "Id Novedad",
      "Tipo Identificación Conductor",
      "Número Identificación",
      "Primer Nombre Conductor",
      "Segundo Nombre Conductor",
      "Primer Apellido Conductor",
      "Segundo Apellido Conductor",
      "Estado"
    ],
    keys: [
      "id",
      "id_novedad",
      "tipo_identificacion_conductor",
      "numero_identificacion",
      "primer_nombre_conductor",
      "segundo_nombre_conductor",
      "primer_apellido_conductor",
      "segundo_apellido_conductor",
      "estado"
    ]
  },

  LlegadasVehiculo: {
    headers: [
      "Id",
      "Id Llegada",
      "Placa",
      "SOAT",
      "Fecha Vencimiento SOAT",
      "Revisión Técnico Mecánica",
      "Observaciones",
      "Estado"
    ],
    keys: [
      "id",
      "llegada_id",
      "placa",
      "soat",
      "fechavencimiento_soat",
      "revisiontecnicomecanica",
      "observaciones",
      "estado"
    ]
  },

  LlegadasConductor: {
    headers: [
      "Id",
      "Id Llegada",
      "Tipo Identificación Conductor",
      "Número Identificación",
      "Primer Nombre Conductor",
      "Segundo Nombre Conductor",
      "Primer Apellido Conductor",
      "Segundo Apellido Conductor",
      "Estado"
    ],
    keys: [
      "id",
      "llegada_id",
      "tipoidentificacionconductor",
      "numeroidentificacion",
      "primernombreconductor",
      "segundonombreconductor",
      "primerapellidoconductor",
      "segundoapellidoconductor",
      "estado"
    ]
  }
};